import React, { useEffect, useMemo, useState } from "react";
import config from "../../config";

const initialFormState = {
  full_name: "",
  mobile: "",
  alternate_mobile: "",
  email: "",
  password: "",
  gender: "",
  dob: "",
  experience_years: "",
  address: "",
  city: "",
  preferred_areas: [],
  pincode: "",
  service_category: "",
  service_name: "",
  service_types: [],
  bio: "",
  availability: "",
  id_proof_type: "",
  id_card_number: "",
  profile_photo: null,
  id_proof_front: null,
  id_proof_back: null,
  extra_fields: {},
};

const styles = {
  page: {
	minHeight: "100vh",
	background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 50%, #eef2ff 100%)",
	padding: "30px 20px",
	fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
  },
  wrapper: {
	maxWidth: "1580px",
	width: "96%",
	margin: "0 auto",
  },
  hero: {
	background: "linear-gradient(135deg, #0f172a, #1d4ed8, #38bdf8)",
	color: "#fff",
	borderRadius: "28px",
	padding: "34px 36px",
	boxShadow: "0 20px 40px rgba(37, 99, 235, 0.22)",
	marginBottom: "24px",
  },
  heroBadge: {
	display: "inline-block",
	background: "rgba(255,255,255,0.14)",
	padding: "7px 14px",
	borderRadius: "999px",
	fontSize: "12px",
	fontWeight: "700",
	marginBottom: "12px",
  },
  heroTitle: {
	margin: 0,
	fontSize: "2.1rem",
	fontWeight: "800",
  },
  heroText: {
	marginTop: "10px",
	marginBottom: 0,
	color: "rgba(255,255,255,0.9)",
	maxWidth: "950px",
	lineHeight: 1.6,
	fontSize: "15px",
  },
  formCard: {
	background: "#fff",
	borderRadius: "28px",
	border: "1px solid #e5edf8",
	boxShadow: "0 14px 34px rgba(15, 23, 42, 0.08)",
	overflow: "hidden",
	width: "100%",
	maxWidth: "1320px",
	margin: "0 auto",
  },
  formHeader: {
	padding: "28px 40px",
	borderBottom: "1px solid #edf2f7",
	background: "linear-gradient(180deg, #ffffff, #f8fbff)",
  },
  formTitle: {
	margin: 0,
	fontSize: "1.7rem",
	fontWeight: "800",
	color: "#0f172a",
  },
  formSub: {
	margin: "8px 0 0 0",
	color: "#64748b",
	fontSize: "14px",
	lineHeight: 1.6,
  },
  body: {
	padding: "32px 40px 36px",
  },
  section: {
	marginBottom: "28px",
	padding: "24px",
	borderRadius: "20px",
	background: "#f8fbff",
	border: "1px solid #e6eef8",
  },
  sectionTitle: {
	margin: "0 0 18px 0",
	fontSize: "1.08rem",
	fontWeight: "800",
	color: "#0f172a",
  },
  helper: {
	color: "#64748b",
	fontSize: "13px",
	margin: "0 0 14px 0",
	lineHeight: 1.6,
  },
  grid: {
	display: "grid",
	gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
	gap: "20px",
	alignItems: "start",
  },
  field: {
	display: "flex",
	flexDirection: "column",
	gap: "8px",
  },
  fullWidth: {
	gridColumn: "1 / -1",
  },
  label: {
	fontSize: "14px",
	fontWeight: "700",
	color: "#334155",
  },
  input: {
	width: "100%",
	padding: "14px 16px",
	borderRadius: "14px",
	border: "1px solid #d6deeb",
	fontSize: "15px",
	outline: "none",
	background: "#fff",
	boxSizing: "border-box",
  },
  select: {
	width: "100%",
	padding: "14px 16px",
	borderRadius: "14px",
	border: "1px solid #d6deeb",
	fontSize: "15px",
	outline: "none",
	background: "#fff",
	boxSizing: "border-box",
  },
  textarea: {
	width: "100%",
	minHeight: "120px",
	padding: "14px 16px",
	borderRadius: "14px",
	border: "1px solid #d6deeb",
	fontSize: "15px",
	outline: "none",
	background: "#fff",
	boxSizing: "border-box",
	resize: "vertical",
  },
  fileInput: {
	width: "100%",
	padding: "12px 14px",
	borderRadius: "14px",
	border: "1px solid #d6deeb",
	fontSize: "14px",
	outline: "none",
	background: "#fff",
	boxSizing: "border-box",
  },
  checkboxGrid: {
	display: "grid",
	gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
	gap: "12px",
  },
  checkboxRow: {
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "12px",
	padding: "12px 14px",
	borderRadius: "14px",
	border: "1px solid #dbe7f5",
	background: "#fff",
  },
  checkboxTextWrap: {
	display: "flex",
	flexDirection: "column",
	gap: "2px",
  },
  checkboxLabel: {
	fontSize: "14px",
	fontWeight: "600",
	color: "#0f172a",
  },
  checkbox: {
	width: "18px",
	height: "18px",
	cursor: "pointer",
	flexShrink: 0,
  },
  inlineCheckbox: {
	display: "flex",
	alignItems: "center",
	gap: "10px",
	padding: "12px 14px",
	borderRadius: "14px",
	border: "1px solid #dbe7f5",
	background: "#fff",
	minHeight: "52px",
  },
  nestedCard: {
	border: "1px solid #dbe7f5",
	borderRadius: "16px",
	padding: "14px",
	background: "#fff",
	marginBottom: "14px",
  },
  nestedTitle: {
	marginBottom: "12px",
	fontSize: "14px",
	fontWeight: "700",
	color: "#0f172a",
  },
  serviceSelectGrid: {
	display: "grid",
	gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
	gap: "18px 26px",
  },
  serviceSelectCard: {
	display: "flex",
	alignItems: "flex-start",
	gap: "14px",
	padding: "16px 18px",
	minHeight: "72px",
	borderRadius: "18px",
	border: "1px solid transparent",
	background: "transparent",
	cursor: "pointer",
	transition: "all 0.2s ease",
	boxSizing: "border-box",
  },
  serviceSelectCardActive: {
	background: "#eaf1fb",
	borderLeft: "4px solid #2563eb",
	borderTopLeftRadius: "18px",
	borderBottomLeftRadius: "18px",
  },
  serviceCheckbox: {
	width: "22px",
	height: "22px",
	marginTop: "2px",
	accentColor: "#2563eb",
	cursor: "pointer",
	flexShrink: 0,
  },
  serviceSelectTextWrap: {
	display: "flex",
	flexDirection: "column",
	gap: "4px",
  },
  serviceSelectLabel: {
	fontSize: "15px",
	fontWeight: "700",
	color: "#334155",
	lineHeight: 1.5,
  },
  message: {
	marginBottom: "20px",
	padding: "14px 16px",
	borderRadius: "16px",
	background: "#eef6ff",
	color: "#0b529b",
	fontSize: "14px",
	border: "1px solid #d9e9ff",
  },
  errorText: {
	color: "#dc2626",
	fontSize: "13px",
	fontWeight: "600",
	marginTop: "4px",
  },
  submitWrap: {
	display: "flex",
	justifyContent: "center",
	marginTop: "30px",
  },
  submitBtn: {
	border: "none",
	borderRadius: "999px",
	background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
	color: "#fff",
	padding: "15px 34px",
	fontSize: "15px",
	fontWeight: "800",
	minWidth: "260px",
	boxShadow: "0 12px 24px rgba(37, 99, 235, 0.24)",
	cursor: "pointer",
  },
};

const getCategoryOptions = () => {
  return Object.entries(config.SERVICE_CONFIG || {}).map(([value, category]) => ({
	value,
	label: category.label,
  }));
};

const getServiceOptions = (categoryKey) => {
  if (!categoryKey || !config.SERVICE_CONFIG?.[categoryKey]?.services) return [];
  return Object.entries(config.SERVICE_CONFIG[categoryKey].services).map(
	([value, service]) => ({
	  value,
	  label: service.label,
	})
  );
};

const getServiceDetails = (categoryKey, serviceKey) => {
  return config.SERVICE_CONFIG?.[categoryKey]?.services?.[serviceKey] || null;
};

const getTypeOptions = (serviceDetails) => {
  if (!serviceDetails) return [];
  if (Array.isArray(serviceDetails.types)) return serviceDetails.types;
  if (Array.isArray(serviceDetails.cleaningTypes)) return serviceDetails.cleaningTypes;
  if (Array.isArray(serviceDetails.supplyTypes)) return serviceDetails.supplyTypes;
  if (Array.isArray(serviceDetails.flatTypes)) return serviceDetails.flatTypes;
  if (serviceDetails.requirementFields?.serviceNeeds) {
	return serviceDetails.requirementFields.serviceNeeds;
  }
  return [];
};

const getAreaOptionsByCity = (city) => {
  if (!city) return [];
  return config.AREA_OPTIONS?.[city]?.areas || [];
};

const getAreaLimitByCity = (city) => {
  if (!city) return 0;
  return config.AREA_OPTIONS?.[city]?.limit || 0;
};

const getDynamicExtraFields = (categoryKey, serviceKey, serviceDetails) => {
  const fields = [];
  if (!serviceDetails) return fields;

  if (serviceKey === config.COOKING_SERVICE) {
	fields.push(
	  {
		name: "food_type",
		label: "Food Type",
		type: "checkbox-group",
		options: [
		  { value: "veg", label: "Veg" },
		  { value: "non-veg", label: "Non-Veg" },
		  { value: "both", label: "Both" },
		],
	  },
	  {
		name: "meal_time_experience",
		label: "Meal Time Experience",
		type: "checkbox-group",
		options: [
		  { value: "breakfast", label: "Breakfast" },
		  { value: "lunch", label: "Lunch" },
		  { value: "dinner", label: "Dinner" },
		],
	  },
	  {
		name: "serving_capacity",
		label: "Serving Capacity",
		type: "number",
		placeholder: "How many people can cook for",
	  },
	  {
		name: "special_diet_supported",
		label: "Special Diet Supported",
		type: "checkbox",
	  },
	  {
		name: "can_buy_groceries",
		label: "Can Buy Groceries",
		type: "checkbox",
	  }
	);
  }

  if (serviceKey === config.GARDENING_SERVICE) {
	const rf = serviceDetails.requirementFields || {};
	fields.push(
	  {
		name: "garden_types",
		label: "Garden Types",
		type: "checkbox-group",
		options: rf.gardenTypes || [],
	  },
	  {
		name: "property_sizes",
		label: "Property Sizes",
		type: "checkbox-group",
		options: rf.propertySizes || [],
	  },
	  {
		name: "service_needs_supported",
		label: "Service Needs Supported",
		type: "checkbox-group",
		options: rf.serviceNeeds || [],
	  }
	);
  }

  if (serviceKey === config.CAR_DRIVER_SERVICE) {
	fields.push(
	  {
		name: "driving_license_number",
		label: "Driving License Number",
		type: "text",
		placeholder: "Enter driving license number",
	  },
	  {
		name: "license_expiry_date",
		label: "License Expiry Date",
		type: "date",
	  },
	  {
		name: "seating_models",
		label: "Seating Models Experience",
		type: "checkbox-group-nested",
		options: serviceDetails.seating_models || [],
	  },
	  {
		name: "outstation_available",
		label: "Available for Outstation Trip",
		type: "checkbox",
	  }
	);
  }

  if (serviceKey === config.PAINTING_SERVICE) {
	fields.push({
	  name: "flat_types",
	  label: "Flat Types Experience",
	  type: "checkbox-group",
	  options: serviceDetails.flatTypes || [],
	});
  }

  if (serviceKey === config.DRINKING_WATER_SERVICE) {
	fields.push({
	  name: "supply_types",
	  label: "Supported Supply Types",
	  type: "checkbox-group",
	  options: serviceDetails.supplyTypes || [],
	});
  }

  if (serviceKey === config.SUMP_TANK_SERVICE) {
	fields.push({
	  name: "cleaning_types",
	  label: "Supported Cleaning Types",
	  type: "checkbox-group",
	  options: serviceDetails.cleaningTypes || [],
	});
  }

  if (categoryKey === config.INSURANCE_SERVICE_CATEGORY) {
	fields.push(
	  {
		name: "agent_license_number",
		label: "Agent License Number",
		type: "text",
		placeholder: "Enter insurance license number",
	  },
	  {
		name: "irda_registered",
		label: "IRDA Registered",
		type: "checkbox",
	  }
	);
  }

  return fields;
};

const LabourSignup = () => {
  const [formValues, setFormValues] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const categoryOptions = useMemo(() => getCategoryOptions(), []);
  const serviceOptions = useMemo(
	() => getServiceOptions(formValues.service_category),
	[formValues.service_category]
  );

  const serviceDetails = useMemo(
	() => getServiceDetails(formValues.service_category, formValues.service_name),
	[formValues.service_category, formValues.service_name]
  );

  const typeOptions = useMemo(() => getTypeOptions(serviceDetails), [serviceDetails]);
  const areaOptions = useMemo(() => getAreaOptionsByCity(formValues.city), [formValues.city]);
  const areaLimit = useMemo(() => getAreaLimitByCity(formValues.city), [formValues.city]);

  const extraFields = useMemo(
	() =>
	  getDynamicExtraFields(
		formValues.service_category,
		formValues.service_name,
		serviceDetails
	  ),
	[formValues.service_category, formValues.service_name, serviceDetails]
  );

  useEffect(() => {
	setFormValues((prev) => ({
	  ...prev,
	  service_name: "",
	  service_types: [],
	  extra_fields: {},
	}));
  }, [formValues.service_category]);

  useEffect(() => {
	setFormValues((prev) => ({
	  ...prev,
	  service_types: [],
	  extra_fields: {},
	}));
  }, [formValues.service_name]);

  const updateField = (name, value) => {
	setFormValues((prev) => ({
	  ...prev,
	  [name]: value,
	  ...(name === "city" ? { preferred_areas: [] } : {}),
	}));
	setErrors((prev) => ({ ...prev, [name]: "" }));
	if (name === "city") setMessage("");
  };

  const updateExtraField = (name, value) => {
	setFormValues((prev) => ({
	  ...prev,
	  extra_fields: {
		...prev.extra_fields,
		[name]: value,
	  },
	}));
	setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCheckboxGroup = (name, optionValue, checked, isExtra = false) => {
	if (isExtra) {
	  const current = formValues.extra_fields[name] || [];
	  const updated = checked
		? [...current, optionValue]
		: current.filter((item) => item !== optionValue);
	  updateExtraField(name, [...new Set(updated)]);
	  return;
	}

	const current = formValues[name] || [];
	const updated = checked
	  ? [...current, optionValue]
	  : current.filter((item) => item !== optionValue);
	updateField(name, [...new Set(updated)]);
  };

  const handleNestedCheckboxGroup = (fieldName, seatingValue, modelValue, checked) => {
	const current = formValues.extra_fields[fieldName] || {};
	const selectedModels = current[seatingValue] || [];
	const updatedModels = checked
	  ? [...selectedModels, modelValue]
	  : selectedModels.filter((item) => item !== modelValue);

	updateExtraField(fieldName, {
	  ...current,
	  [seatingValue]: [...new Set(updatedModels)],
	});
  };

  const handleAreaSelection = (area, checked) => {
	const current = formValues.preferred_areas || [];
	let updated = checked
	  ? [...current, area]
	  : current.filter((item) => item !== area);

	updated = [...new Set(updated)];

	if (areaLimit && updated.length > areaLimit) {
	  setMessage(`You can select only ${areaLimit} area(s) for ${formValues.city}.`);
	  return;
	}

	setMessage("");
	updateField("preferred_areas", updated);
  };

  const handleFileChange = (e) => {
	const { name, files } = e.target;
	updateField(name, files?.[0] || null);
  };

  const validateForm = () => {
	const newErrors = {};

	if (!formValues.full_name.trim()) newErrors.full_name = "Full name is required";
	if (!formValues.mobile.trim()) {
	  newErrors.mobile = "Mobile number is required";
	} else if (!/^\d{10}$/.test(formValues.mobile)) {
	  newErrors.mobile = "Mobile number must be exactly 10 digits";
	}

	if (!formValues.password.trim()) {
	  newErrors.password = "Password is required";
	} else if (!/^\d{4}$/.test(formValues.password)) {
	  newErrors.password = "Password must be exactly 4 digits";
	}

	if (
	  formValues.alternate_mobile &&
	  !/^\d{10}$/.test(formValues.alternate_mobile)
	) {
	  newErrors.alternate_mobile = "Alternate mobile number must be exactly 10 digits";
	}

	if (!formValues.gender) newErrors.gender = "Gender is required";
	if (!formValues.dob) newErrors.dob = "Date of birth is required";
	if (!formValues.address.trim()) newErrors.address = "Address is required";
	if (!formValues.city) newErrors.city = "City is required";

	if (!formValues.pincode.trim()) {
	  newErrors.pincode = "Pincode is required";
	} else if (!/^\d{6}$/.test(formValues.pincode)) {
	  newErrors.pincode = "Pincode must be exactly 6 digits";
	}

	if (!formValues.service_category) {
	  newErrors.service_category = "Service category is required";
	}

	if (!formValues.service_name) newErrors.service_name = "Service is required";
	if (!formValues.service_types.length) {
	  newErrors.service_types = "Select at least one service type";
	}

	if (!formValues.id_proof_type) {
	  newErrors.id_proof_type = "ID proof type is required";
	}

	if (!formValues.id_card_number.trim()) {
	  newErrors.id_card_number = "Identity card number is required";
	}

	if (!formValues.profile_photo) {
	  newErrors.profile_photo = "Profile photo is required";
	}

	if (!formValues.id_proof_front) {
	  newErrors.id_proof_front = "ID proof front photo is required";
	}

	if (formValues.service_name === config.COOKING_SERVICE) {
	  if (!(formValues.extra_fields.food_type || []).length) {
		newErrors.food_type = "Select food type";
	  }
	  if (!(formValues.extra_fields.meal_time_experience || []).length) {
		newErrors.meal_time_experience = "Select meal time experience";
	  }
	}

	if (formValues.service_name === config.CAR_DRIVER_SERVICE) {
	  if (!formValues.extra_fields.driving_license_number?.trim()) {
		newErrors.driving_license_number = "Driving license number is required";
	  }
	}

	setErrors(newErrors);
	return Object.keys(newErrors).length === 0;
  };

  const buildWorkerFormData = () => {
	const payload = new FormData();

	Object.keys(formValues).forEach((key) => {
	  if (["service_types", "preferred_areas", "extra_fields"].includes(key)) {
		payload.append(key, JSON.stringify(formValues[key] || []));
	  } else if (["profile_photo", "id_proof_front", "id_proof_back"].includes(key)) {
		if (formValues[key]) payload.append(key, formValues[key]);
	  } else {
		payload.append(key, formValues[key] || "");
	  }
	});

	return payload;
  };

  const handleSubmit = async (e) => {
	e.preventDefault();
	setMessage("");

	if (!validateForm()) return;

	try {
	  setSubmitting(true);
	  const payload = buildWorkerFormData();

	  const response = await fetch(`${config.API_BASE_URL}/api/labour/labour-register-form/`, {
		method: "POST",
		body: payload,
	  });

	  const data = await response.json();

	  if (!response.ok) {
		throw new Error(data?.message || "Failed to register worker");
	  }

	  setMessage(data?.message || "Worker registered successfully");
	  setFormValues(initialFormState);
	  setErrors({});
	} catch (error) {
	  setMessage(error.message || "Something went wrong");
	} finally {
	  setSubmitting(false);
	}
  };

  const renderCheckboxGroup = (
	fieldName,
	options = [],
	isExtra = false,
	useServiceStyle = false
  ) => {
	const selectedValues = isExtra
	  ? formValues.extra_fields[fieldName] || []
	  : formValues[fieldName] || [];

	if (useServiceStyle) {
	  return (
		<fieldset style={{ border: "none", padding: 0, margin: 0 }}>
		  <legend style={{ ...styles.helper, marginBottom: "12px" }}>
			Select one or more services the worker can provide.
		  </legend>
		  <div style={styles.serviceSelectGrid}>
			{options.map((item) => {
			  const inputId = `${fieldName}-${item.value}`;
			  const isChecked = selectedValues.includes(item.value);

			  return (
				<label
				  key={item.value}
				  htmlFor={inputId}
				  style={{
					...styles.serviceSelectCard,
					...(isChecked ? styles.serviceSelectCardActive : {}),
				  }}
				>
				  <input
					id={inputId}
					style={styles.serviceCheckbox}
					type="checkbox"
					checked={isChecked}
					onChange={(e) =>
					  handleCheckboxGroup(fieldName, item.value, e.target.checked, isExtra)
					}
				  />
				  <div style={styles.serviceSelectTextWrap}>
					<span style={styles.serviceSelectLabel}>{item.label}</span>
				  </div>
				</label>
			  );
			})}
		  </div>
		</fieldset>
	  );
	}

	return (
	  <fieldset style={{ border: "none", padding: 0, margin: 0 }}>
		<div style={styles.checkboxGrid}>
		  {options.map((item) => {
			const inputId = `${fieldName}-${item.value}`;
			return (
			  <label key={item.value} htmlFor={inputId} style={styles.checkboxRow}>
				<div style={styles.checkboxTextWrap}>
				  <span style={styles.checkboxLabel}>{item.label}</span>
				</div>
				<input
				  id={inputId}
				  style={styles.checkbox}
				  type="checkbox"
				  checked={selectedValues.includes(item.value)}
				  onChange={(e) =>
					handleCheckboxGroup(fieldName, item.value, e.target.checked, isExtra)
				  }
				/>
			  </label>
			);
		  })}
		</div>
	  </fieldset>
	);
  };

  const renderExtraField = (field) => {
	const value = formValues.extra_fields[field.name];

	if (field.type === "text" || field.type === "number" || field.type === "date") {
	  return (
		<div style={styles.field} key={field.name}>
		  <label htmlFor={field.name} style={styles.label}>
			{field.label}
		  </label>
		  <input
			id={field.name}
			style={styles.input}
			type={field.type}
			placeholder={field.placeholder || ""}
			value={value || ""}
			onChange={(e) => updateExtraField(field.name, e.target.value)}
		  />
		  {errors[field.name] && <small style={styles.errorText}>{errors[field.name]}</small>}
		</div>
	  );
	}

	if (field.type === "checkbox") {
	  return (
		<div style={styles.field} key={field.name}>
		  <label htmlFor={field.name} style={styles.inlineCheckbox}>
			<input
			  id={field.name}
			  style={styles.checkbox}
			  type="checkbox"
			  checked={!!value}
			  onChange={(e) => updateExtraField(field.name, e.target.checked)}
			/>
			<span style={styles.checkboxLabel}>{field.label}</span>
		  </label>
		</div>
	  );
	}

	if (field.type === "checkbox-group") {
	  return (
		<div style={{ ...styles.field, ...styles.fullWidth }} key={field.name}>
		  <label style={styles.label}>{field.label}</label>
		  {renderCheckboxGroup(field.name, field.options, true, false)}
		  {errors[field.name] && <small style={styles.errorText}>{errors[field.name]}</small>}
		</div>
	  );
	}

	if (field.type === "checkbox-group-nested") {
	  return (
		<div style={{ ...styles.field, ...styles.fullWidth }} key={field.name}>
		  <label style={styles.label}>{field.label}</label>
		  {(field.options || []).map((seat) => (
			<div key={seat.value} style={styles.nestedCard}>
			  <div style={styles.nestedTitle}>{seat.label}</div>
			  <div style={styles.checkboxGrid}>
				{(seat.models || []).map((model) => {
				  const inputId = `${field.name}-${seat.value}-${model.value}`;
				  return (
					<label key={model.value} htmlFor={inputId} style={styles.checkboxRow}>
					  <div style={styles.checkboxTextWrap}>
						<span style={styles.checkboxLabel}>{model.label}</span>
					  </div>
					  <input
						id={inputId}
						style={styles.checkbox}
						type="checkbox"
						checked={
						  !!formValues.extra_fields?.[field.name]?.[seat.value]?.includes(
							model.value
						  )
						}
						onChange={(e) =>
						  handleNestedCheckboxGroup(
							field.name,
							seat.value,
							model.value,
							e.target.checked
						  )
						}
					  />
					</label>
				  );
				})}
			  </div>
			</div>
		  ))}
		</div>
	  );
	}

	return null;
  };

  return (
	<div style={styles.page}>
	  <div style={styles.wrapper}>
		<div style={styles.hero}>
		  <div style={styles.heroBadge}>Worker Onboarding</div>
		  <h1 style={styles.heroTitle}>Register Labour / Worker Profile</h1>
		  <p style={styles.heroText}>
			Fill in personal details, service preferences, work areas, and identity proof
			to create a complete worker registration profile.
		  </p>
		</div>

		<form style={styles.formCard} onSubmit={handleSubmit}>
		  <div style={styles.formHeader}>
			<h2 style={styles.formTitle}>Worker Registration Form</h2>
			<p style={styles.formSub}>
			  Complete the registration with personal details, service information,
			  preferred work areas, documents, and optional extra skills based on
			  selected service type.
			</p>
		  </div>

		  <div style={styles.body}>
			{message && <div style={styles.message}>{message}</div>}

			<div style={styles.section}>
			  <h3 style={styles.sectionTitle}>Personal Details</h3>
			  <div style={styles.grid}>
				<div style={styles.field}>
				  <label htmlFor="full_name" style={styles.label}>Full Name</label>
				  <input
					id="full_name"
					style={styles.input}
					type="text"
					value={formValues.full_name}
					onChange={(e) => updateField("full_name", e.target.value)}
				  />
				  {errors.full_name && <small style={styles.errorText}>{errors.full_name}</small>}
				</div>

				<div style={styles.field}>
				  <label htmlFor="mobile" style={styles.label}>Mobile Number</label>
				  <input
					id="mobile"
					style={styles.input}
					type="text"
					inputMode="numeric"
					maxLength={10}
					value={formValues.mobile}
					onChange={(e) => updateField("mobile", e.target.value.replace(/\D/g, ""))}
				  />
				  {errors.mobile && <small style={styles.errorText}>{errors.mobile}</small>}
				</div>

				<div style={styles.field}>
				  <label htmlFor="alternate_mobile" style={styles.label}>Alternate Mobile Number</label>
				  <input
					id="alternate_mobile"
					style={styles.input}
					type="text"
					inputMode="numeric"
					maxLength={10}
					value={formValues.alternate_mobile}
					onChange={(e) =>
					  updateField("alternate_mobile", e.target.value.replace(/\D/g, ""))
					}
				  />
				  {errors.alternate_mobile && (
					<small style={styles.errorText}>{errors.alternate_mobile}</small>
				  )}
				</div>

				<div style={styles.field}>
				  <label htmlFor="email" style={styles.label}>Email</label>
				  <input
					id="email"
					style={styles.input}
					type="email"
					value={formValues.email}
					onChange={(e) => updateField("email", e.target.value)}
				  />
				</div>

				<div style={styles.field}>
				  <label htmlFor="password" style={styles.label}>Password</label>
				  <input
					id="password"
					style={styles.input}
					type="password"
					inputMode="numeric"
					maxLength={4}
					value={formValues.password}
					onChange={(e) =>
					  updateField("password", e.target.value.replace(/\D/g, ""))
					}
					placeholder="Enter 4-digit password"
				  />
				  {errors.password && <small style={styles.errorText}>{errors.password}</small>}
				</div>

				<div style={styles.field}>
				  <label htmlFor="gender" style={styles.label}>Gender</label>
				  <select
					id="gender"
					style={styles.select}
					value={formValues.gender}
					onChange={(e) => updateField("gender", e.target.value)}
				  >
					<option value="">Select Gender</option>
					<option value="male">Male</option>
					<option value="female">Female</option>
					<option value="other">Other</option>
				  </select>
				  {errors.gender && <small style={styles.errorText}>{errors.gender}</small>}
				</div>

				<div style={styles.field}>
				  <label htmlFor="dob" style={styles.label}>Date of Birth</label>
				  <input
					id="dob"
					style={styles.input}
					type="date"
					value={formValues.dob}
					onChange={(e) => updateField("dob", e.target.value)}
				  />
				  {errors.dob && <small style={styles.errorText}>{errors.dob}</small>}
				</div>

				<div style={styles.field}>
				  <label htmlFor="experience_years" style={styles.label}>Experience Years</label>
				  <input
					id="experience_years"
					style={styles.input}
					type="number"
					value={formValues.experience_years}
					onChange={(e) => updateField("experience_years", e.target.value)}
				  />
				</div>

				<div style={styles.field}>
				  <label htmlFor="availability" style={styles.label}>Availability</label>
				  <select
					id="availability"
					style={styles.select}
					value={formValues.availability}
					onChange={(e) => updateField("availability", e.target.value)}
				  >
					<option value="">Select Availability</option>
					<option value="full-time">Full Time</option>
					<option value="part-time">Part Time</option>
					<option value="weekends">Weekends</option>
					<option value="night-shift">Night Shift</option>
				  </select>
				</div>
			  </div>
			</div>

			<div style={styles.section}>
			  <h3 style={styles.sectionTitle}>Location Details</h3>
			  <p style={styles.helper}>
				Select city first, then choose preferred work areas based on allowed area limit.
			  </p>
			  <div style={styles.grid}>
				<div style={styles.field}>
				  <label htmlFor="city" style={styles.label}>City</label>
				  <select
					id="city"
					style={styles.select}
					value={formValues.city}
					onChange={(e) => updateField("city", e.target.value)}
				  >
					<option value="">Select City</option>
					{Object.keys(config.AREA_OPTIONS || {}).map((city) => (
					  <option key={city} value={city}>
						{city.charAt(0).toUpperCase() + city.slice(1)}
					  </option>
					))}
				  </select>
				  {errors.city && <small style={styles.errorText}>{errors.city}</small>}
				</div>

				<div style={styles.field}>
				  <label htmlFor="pincode" style={styles.label}>Pincode</label>
				  <input
					id="pincode"
					style={styles.input}
					type="text"
					inputMode="numeric"
					maxLength={6}
					value={formValues.pincode}
					onChange={(e) => updateField("pincode", e.target.value.replace(/\D/g, ""))}
				  />
				  {errors.pincode && <small style={styles.errorText}>{errors.pincode}</small>}
				</div>

				<div style={{ ...styles.field, ...styles.fullWidth }}>
				  <label htmlFor="address" style={styles.label}>Address</label>
				  <textarea
					id="address"
					style={styles.textarea}
					value={formValues.address}
					onChange={(e) => updateField("address", e.target.value)}
				  />
				  {errors.address && <small style={styles.errorText}>{errors.address}</small>}
				</div>

				<div style={{ ...styles.field, ...styles.fullWidth }}>
				  <label style={styles.label}>Preferred Areas</label>
				  <fieldset style={{ border: "none", padding: 0, margin: 0 }}>
					<legend style={{ ...styles.helper, marginBottom: "12px" }}>
					  {areaLimit
						? `You can choose up to ${areaLimit} area(s) in ${formValues.city || "selected city"}.`
						: "Choose areas where the worker prefers to work."}
					</legend>
					<div style={styles.checkboxGrid}>
					  {areaOptions.map((area) => {
						const inputId = `preferred-area-${area}`;
						return (
						  <label key={area} htmlFor={inputId} style={styles.checkboxRow}>
							<div style={styles.checkboxTextWrap}>
							  <span style={styles.checkboxLabel}>{area}</span>
							</div>
							<input
							  id={inputId}
							  style={styles.checkbox}
							  type="checkbox"
							  checked={formValues.preferred_areas.includes(area)}
							  onChange={(e) => handleAreaSelection(area, e.target.checked)}
							/>
						  </label>
						);
					  })}
					</div>
				  </fieldset>
				</div>
			  </div>
			</div>

			<div style={styles.section}>
			  <h3 style={styles.sectionTitle}>Service Information</h3>
			  <div style={styles.grid}>
				<div style={styles.field}>
				  <label htmlFor="service_category" style={styles.label}>Service Category</label>
				  <select
					id="service_category"
					style={styles.select}
					value={formValues.service_category}
					onChange={(e) => updateField("service_category", e.target.value)}
				  >
					<option value="">Select Category</option>
					{categoryOptions.map((item) => (
					  <option key={item.value} value={item.value}>
						{item.label}
					  </option>
					))}
				  </select>
				  {errors.service_category && (
					<small style={styles.errorText}>{errors.service_category}</small>
				  )}
				</div>

				<div style={styles.field}>
				  <label htmlFor="service_name" style={styles.label}>Service</label>
				  <select
					id="service_name"
					style={styles.select}
					value={formValues.service_name}
					onChange={(e) => updateField("service_name", e.target.value)}
				  >
					<option value="">Select Service</option>
					{serviceOptions.map((item) => (
					  <option key={item.value} value={item.value}>
						{item.label}
					  </option>
					))}
				  </select>
				  {errors.service_name && (
					<small style={styles.errorText}>{errors.service_name}</small>
				  )}
				</div>

				<div style={{ ...styles.field, ...styles.fullWidth }}>
				  <label style={styles.label}>Service Types</label>
				  {renderCheckboxGroup("service_types", typeOptions, false, true)}
				  {errors.service_types && (
					<small style={styles.errorText}>{errors.service_types}</small>
				  )}
				</div>
			  </div>
			</div>

			{extraFields.length > 0 && (
			  <div style={styles.section}>
				<h3 style={styles.sectionTitle}>Extra Service Fields</h3>
				<p style={styles.helper}>
				  These fields change automatically based on selected category and service.
				</p>
				<div style={styles.grid}>
				  {extraFields.map((field) => renderExtraField(field))}
				</div>
			  </div>
			)}

			<div style={styles.section}>
			  <h3 style={styles.sectionTitle}>Documents</h3>
			  <div style={styles.grid}>
				<div style={{ ...styles.field, ...styles.fullWidth }}>
				  <label htmlFor="bio" style={styles.label}>About Worker</label>
				  <textarea
					id="bio"
					style={styles.textarea}
					value={formValues.bio}
					onChange={(e) => updateField("bio", e.target.value)}
				  />
				</div>

				<div style={styles.field}>
				  <label htmlFor="id_proof_type" style={styles.label}>ID Proof Type</label>
				  <select
					id="id_proof_type"
					style={styles.select}
					value={formValues.id_proof_type}
					onChange={(e) => updateField("id_proof_type", e.target.value)}
				  >
					<option value="">Select ID Proof</option>
					<option value="aadhaar">Aadhaar</option>
					<option value="pan">PAN</option>
					<option value="voterid">Voter ID</option>
					<option value="drivinglicense">Driving License</option>
					<option value="passport">Passport</option>
				  </select>
				  {errors.id_proof_type && (
					<small style={styles.errorText}>{errors.id_proof_type}</small>
				  )}
				</div>

				<div style={styles.field}>
				  <label htmlFor="id_card_number" style={styles.label}>Identity Card Number</label>
				  <input
					id="id_card_number"
					style={styles.input}
					type="text"
					value={formValues.id_card_number}
					onChange={(e) => updateField("id_card_number", e.target.value)}
				  />
				  {errors.id_card_number && (
					<small style={styles.errorText}>{errors.id_card_number}</small>
				  )}
				</div>

				<div style={styles.field}>
				  <label htmlFor="profile_photo" style={styles.label}>Profile Photo</label>
				  <input
					id="profile_photo"
					style={styles.fileInput}
					type="file"
					name="profile_photo"
					accept="image/*"
					onChange={handleFileChange}
				  />
				  {errors.profile_photo && (
					<small style={styles.errorText}>{errors.profile_photo}</small>
				  )}
				</div>

				<div style={styles.field}>
				  <label htmlFor="id_proof_front" style={styles.label}>ID Proof Front</label>
				  <input
					id="id_proof_front"
					style={styles.fileInput}
					type="file"
					name="id_proof_front"
					accept="image/*"
					onChange={handleFileChange}
				  />
				  {errors.id_proof_front && (
					<small style={styles.errorText}>{errors.id_proof_front}</small>
				  )}
				</div>

				<div style={styles.field}>
				  <label htmlFor="id_proof_back" style={styles.label}>ID Proof Back</label>
				  <input
					id="id_proof_back"
					style={styles.fileInput}
					type="file"
					name="id_proof_back"
					accept="image/*"
					onChange={handleFileChange}
				  />
				</div>
			  </div>
			</div>

			<div style={styles.submitWrap}>
			  <button type="submit" style={styles.submitBtn} disabled={submitting}>
				{submitting ? "Submitting..." : "Register Worker"}
			  </button>
			</div>
		  </div>
		</form>
	  </div>
	</div>
  );
};

export default LabourSignup;